import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AuthRoutingModule } from "./auth-routing.module";
import { SuperloginComponent } from "./superlogin/superlogin.component";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { NbAuthModule, routes } from "@nebular/auth";
import {
  NbAlertModule,
  NbButtonModule,
  NbCheckboxModule,
  NbThemeModule,
  NbLayoutModule,
  NbIconModule,
  NbCardModule,
  NbInputModule,
  NbChatModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { ForgotpasswordComponent } from "./forgotpassword/forgotpassword.component";
import { ResetpasswordComponent } from "./resetpassword/resetpassword.component";
@NgModule({
  declarations: [
    SuperloginComponent,
    ForgotpasswordComponent,
    ResetpasswordComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    RouterModule,
    NbThemeModule,
    NbAlertModule,
    NbIconModule,
    NbInputModule,
    NbButtonModule,
    NbLayoutModule,
    NbCheckboxModule,
    NbCardModule,
    NbChatModule,
    NbDialogModule,
    NbMenuModule,
    NbSidebarModule,
    NbToastrModule.forRoot(),
    NbWindowModule,
    NbAuthModule,
  ],
})
export class AuthModule {}
